<script lang="ts">
    import type { IconDefinition as ID1 } from '@fortawesome/free-solid-svg-icons'
    import type { IconDefinition as ID2 } from '@fortawesome/free-brands-svg-icons'
    import { createEventDispatcher } from 'svelte'
    import Fa from 'svelte-fa'
    const dispatch = createEventDispatcher()

    export let icon: ID1 | ID2
    export let label: string
    let className = ''
    export { className as class }

    function goOnClick() {
        dispatch('click')
    }
</script>

<div class="ztouch_button {className}">
    <div on:click={goOnClick} class="ztouch_button_icon">
        <Fa {icon}></Fa>
    </div>
    <div class="ztouch_button_label">{label}</div>
</div>
